import { Box, Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import DryCleaningIcon from "@mui/icons-material/DryCleaning";
import CarpetIcon from "@mui/icons-material/Layers";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DiamondIcon from "@mui/icons-material/Diamond";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import VerifiedIcon from "@mui/icons-material/Verified";
import ServiceCard from "../components/ServiceCard";
import SectionTitle from "../components/SectionTitle";

const SERVICES = [
  { icon: LocalLaundryServiceIcon, title: "Blanchisserie de Luxe", description: "Entretien expert de votre linge, draps, housses de couette, et plus encore avec soin et précision.", path: "/services/blanchisserie" },
  { icon: DryCleaningIcon, title: "Location & Vente de Linge", description: "Locations et vente de linge de haute qualité pour hôtels et riads, le lavage et remplacement inclus.", path: "/services/location-linge" },
  { icon: CarpetIcon, title: "Nettoyage de Tapis & Mobilier", description: "Nettoyage professionnel de tapis, moquettes et mobilier avec des produits écologiques.", path: "/services/tapis" },
];

const STATS = [
  { value: "24h/7j", label: "Disponibilité" },
  { value: "50+", label: "Clients actifs" },
  { value: "5★", label: "Qualité de service" },
  { value: "20+", label: "Années d'expérience" },
];

const WHY_US = [
  { icon: WorkspacePremiumIcon, title: "Qualité Garantie", desc: "Chaque article est inspecté avant livraison selon nos standards hôteliers stricts." },
  { icon: LocalShippingIcon, title: "Collecte & Livraison", desc: "Ramassage et retour planifiés à votre convenance, 7 jours sur 7." },
  { icon: AccessTimeIcon, title: "Disponible 24h/24", desc: "Notre équipe est joignable à tout moment pour répondre à vos besoins urgents." },
  { icon: DiamondIcon, title: "Expertise Hôtelière", desc: "Spécialisés dans le linge pour hôtels, riads, restaurants et spas de luxe." },
];

/* ─── HERO ──────────────────────────────────────────────── */
const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{
      minHeight: "100vh", position: "relative", display: "flex", alignItems: "center",
      justifyContent: "center", textAlign: "center", overflow: "hidden",
      background: 'url("/images/homepage0.1.png") center/cover no-repeat',
      "&::before": { content: '""', position: "absolute", inset: 0, zIndex: 1, background: "linear-gradient(to bottom, rgba(10,6,2,0.6) 0%, rgba(10,6,2,0.35) 50%, rgba(10,6,2,0.8) 100%)" },
      "&::after": { content: '""', position: "absolute", inset: 0, zIndex: 0, backgroundImage: "radial-gradient(rgba(201,168,76,0.06) 1px, transparent 1px)", backgroundSize: "32px 32px" },
    }}>
      <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: { xs: 200, md: 300 }, height: { xs: 200, md: 300 }, borderRadius: "50%", zIndex: 1, pointerEvents: "none", background: "radial-gradient(circle, rgba(201,168,76,0.18) 0%, transparent 70%)" }} />

      <Container maxWidth="md" sx={{ position: "relative", zIndex: 2, px: { xs: 2, md: 6 } }}>
        <Box component="img" src="/images/logo.png" alt="Luxury Laundry"
          sx={{ width: { xs: 160, md: 280 }, height: { xs: 160, md: 280 }, mx: "auto", display: "block", filter: "drop-shadow(0 2px 24px rgba(201,168,76,0.35))" }}
        />
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, mb: { xs: 2, md: 3 } }}>
          <Box sx={{ width: { xs: 40, md: 60 }, height: "1px", backgroundColor: "rgba(201,168,76,0.45)" }} />
          <Box sx={{ width: 5, height: 5, backgroundColor: "secondary.main", transform: "rotate(45deg)" }} />
          <Box sx={{ width: { xs: 40, md: 60 }, height: "1px", backgroundColor: "rgba(201,168,76,0.45)" }} />
        </Box>
        <Typography variant="h1" sx={{ color: "#fff", fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: { xs: "1.6rem", sm: "2rem", md: "3rem" }, mb: 1.5, lineHeight: 1.1 }}>
          Bienvenue chez <Box component="span" sx={{ color: "secondary.main" }}>Luxury Laundry</Box>
        </Typography>
        <Typography sx={{ color: "rgba(255,255,255,0.72)", fontSize: { xs: "0.88rem", md: "1.05rem" }, lineHeight: 1.9, maxWidth: 540, mx: "auto", mb: { xs: 3, md: 5 } }}>
          Votre expert en blanchisserie de luxe pour hôtels, riads et restaurants à Marrakech — collecte, lavage et livraison 24h/24.
        </Typography>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
          <Button onClick={() => navigate("/services/blanchisserie")} variant="contained" sx={{ backgroundColor: "secondary.main", color: "#1a0f05", fontWeight: 700, fontSize: { xs: "0.7rem", md: "0.78rem" }, letterSpacing: "0.15em", px: { xs: 3, md: 5 }, py: 1.7, borderRadius: 0, border: "1px solid transparent", transition: "all 0.3s ease", "&:hover": { backgroundColor: "transparent", borderColor: "secondary.main", color: "secondary.main" } }}>
            Nos Services
          </Button>
          <Button onClick={() => navigate("/contact")} variant="outlined" sx={{ borderColor: "rgba(255,255,255,0.4)", color: "#fff", fontWeight: 400, fontSize: { xs: "0.7rem", md: "0.78rem" }, letterSpacing: "0.15em", px: { xs: 3, md: 5 }, py: 1.7, borderRadius: 0, transition: "all 0.3s ease", "&:hover": { borderColor: "secondary.main", color: "secondary.main", backgroundColor: "transparent" } }}>
            Contactez-nous
          </Button>
        </Box>
      </Container>

      <Box sx={{ position: "absolute", bottom: -1, left: 0, right: 0, zIndex: 3, lineHeight: 0 }}>
        <svg viewBox="0 0 1440 70" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ display: "block", width: "100%", height: 70 }}>
          <path d="M0,40 C360,80 1080,0 1440,40 L1440,70 L0,70 Z" fill="#f5f0e8" />
        </svg>
      </Box>
    </Box>
  );
};

/* ─── SHARED BG ─────────────────────────────────────────── */
const CreamBg = ({ children }) => (
  <Box sx={{
    position: "relative", backgroundColor: "#f5f0e8",
    "&::before": { content: '""', position: "absolute", inset: 0, zIndex: 0, pointerEvents: "none", background: 'url("/images/flowers.jpg") center/cover no-repeat', opacity: 0.03 },
  }}>
    <Box sx={{ position: "relative", zIndex: 1 }}>{children}</Box>
  </Box>
);

/* ─── STATS ─────────────────────────────────────────────── */
const StatsSection = () => (
  <CreamBg>
    <Box sx={{ py: { xs: 4, md: 6 }, borderTop: "1px solid rgba(201,168,76,0.2)", borderBottom: "1px solid rgba(201,168,76,0.2)" }}>
      <Container maxWidth="lg" sx={{ px: { xs: 2, md: 3 } }}>
        <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: { xs: 3, md: 0 } }}>
          {STATS.map((stat) => (
            <Box key={stat.label} sx={{ flex: "1 1 calc(50% - 12px)", maxWidth: { xs: "calc(50% - 12px)", md: "25%" }, textAlign: "center", position: "relative", "&:not(:last-child)::after": { content: '""', position: "absolute", right: 0, top: "20%", height: "60%", width: "1px", backgroundColor: "rgba(201,168,76,0.3)", display: { xs: "none", md: "block" } } }}>
              <Typography sx={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: { xs: "1.8rem", md: "2.8rem" }, color: "secondary.main", lineHeight: 1 }}>{stat.value}</Typography>
              <Typography sx={{ color: "text.secondary", fontSize: { xs: "0.62rem", md: "0.72rem" }, letterSpacing: "0.18em", textTransform: "uppercase", mt: 1 }}>{stat.label}</Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  </CreamBg>
);

/* ─── ABOUT ─────────────────────────────────────────────── */
const AboutSection = () => (
  <CreamBg>
    <Container maxWidth="md" sx={{ py: { xs: 6, md: 11 }, textAlign: "center", px: { xs: 2, md: 3 } }}>
      <SectionTitle overline="À Propos de Nous" title="Votre Partenaire en Linge Hôtelier à Marrakech" align="center" />
      <Typography sx={{ color: "text.secondary", lineHeight: 2, fontSize: { xs: "0.92rem", md: "1rem" }, mb: 2.5 }}>
        Chez <strong style={{ color: "#1a1108" }}>Luxury Laundry by Zrikem Clean</strong>, nous sommes spécialisés dans la blanchisserie industrielle haut de gamme pour les établissements hôteliers, les riads, les restaurants et les spas de Marrakech.
      </Typography>
      <Typography sx={{ color: "text.secondary", lineHeight: 2, fontSize: { xs: "0.92rem", md: "1rem" }, mb: { xs: 4, md: 5 } }}>
        Notre engagement : vous offrir un linge impeccable, livré à temps, chaque jour — avec la rigueur et l'élégance que méritent vos clients.
      </Typography>

      {/* 3 points — stack on mobile, side by side on desktop */}
      <Box sx={{ display: "flex", gap: { xs: 2, md: 4 }, justifyContent: "center", flexWrap: { xs: "wrap", md: "nowrap" } }}>
        {[
          { icon: LocalShippingIcon, label: "Collecte & Livraison", desc: "7 jours sur 7, planifiée selon vos besoins" },
          { icon: CleaningServicesIcon, label: "Produits Professionnels", desc: "Respectueux des textiles et de l'environnement" },
          { icon: VerifiedIcon, label: "Contrôle Qualité", desc: "Inspection rigoureuse avant chaque livraison" },
        ].map(({ icon: Icon, label, desc }) => (
          <Box key={label} sx={{ flex: { xs: "1 1 calc(50% - 8px)", md: "1 1 200px" }, textAlign: "center" }}>
            <Box sx={{ width: { xs: 55, md: 70 }, height: { xs: 55, md: 70 }, borderRadius: "50%", mx: "auto", mb: 1.5, display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(201,168,76,0.3)", background: "radial-gradient(circle, rgba(201,168,76,0.1) 0%, transparent 70%)" }}>
              <Icon sx={{ fontSize: { xs: 24, md: 32 }, color: "secondary.main" }} />
            </Box>
            <Typography sx={{ fontFamily: "'Playfair Display', serif", fontWeight: 600, color: "text.primary", fontSize: { xs: "0.82rem", md: "0.95rem" }, mb: 0.8 }}>{label}</Typography>
            <Typography sx={{ color: "text.secondary", fontSize: { xs: "0.75rem", md: "0.85rem" }, lineHeight: 1.7 }}>{desc}</Typography>
          </Box>
        ))}
      </Box>
    </Container>
  </CreamBg>
);

/* ─── SERVICES ──────────────────────────────────────────── */
const ServicesSection = () => (
  <CreamBg>
    <Box sx={{ borderTop: "1px solid rgba(201,168,76,0.12)", py: { xs: 6, md: 11 } }}>
      <Container maxWidth="lg" sx={{ px: { xs: 2, md: 3 } }}>
        <SectionTitle overline="Ce Que Nous Offrons" title="Nos Services" align="center" />
        {/* Stack on mobile, side by side on desktop */}
        <Box sx={{ display: "flex", gap: { xs: 2, md: 3 }, flexWrap: { xs: "wrap", md: "nowrap" } }}>
          {SERVICES.map((service) => (
            <Box key={service.title} sx={{ flex: { xs: "1 1 100%", md: "1 1 0" }, minWidth: 0 }}>
              <ServiceCard {...service} compact />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  </CreamBg>
);

/* ─── WHY US ────────────────────────────────────────────── */
const WhyUsSection = () => (
  <CreamBg>
    <Box sx={{ borderTop: "1px solid rgba(201,168,76,0.12)", py: { xs: 6, md: 11 } }}>
      <Container maxWidth="lg" sx={{ px: { xs: 2, md: 3 } }}>
        <SectionTitle overline="Nos Engagements" title="Pourquoi Nous Choisir" align="center" />
        {/* 2 cols on mobile, 4 on desktop */}
        <Box sx={{ display: "flex", gap: { xs: 2, md: 3 }, flexWrap: "wrap" }}>
          {WHY_US.map(({ icon: Icon, title, desc }) => (
            <Box key={title} sx={{
              flex: { xs: "1 1 calc(50% - 8px)", md: "1 1 0" },
              maxWidth: { xs: "calc(50% - 8px)", md: "none" },
              minWidth: 0, textAlign: "center",
              p: { xs: 2, md: 4 },
              border: "1px solid rgba(201,168,76,0.2)", borderRadius: "4px",
              backgroundColor: "#fff", display: "flex", flexDirection: "column", alignItems: "center",
              boxShadow: "0 2px 16px rgba(26,17,8,0.06)", transition: "all 0.3s ease",
              "&:hover": { borderColor: "secondary.main", boxShadow: "0 10px 32px rgba(26,17,8,0.12)", transform: "translateY(-5px)" },
            }}>
              <Box sx={{ width: { xs: 65, md: 100 }, height: { xs: 65, md: 100 }, borderRadius: "50%", mb: { xs: 2, md: 3 }, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(201,168,76,0.3)", background: "radial-gradient(circle, rgba(201,168,76,0.12) 0%, transparent 70%)" }}>
                <Icon sx={{ fontSize: { xs: 30, md: 52 }, color: "secondary.main" }} />
              </Box>
              <Typography sx={{ fontFamily: "'Playfair Display', serif", fontWeight: 600, color: "text.primary", fontSize: { xs: "0.82rem", md: "1.05rem" }, mb: 1.5 }}>{title}</Typography>
              <Box sx={{ width: 25, height: "1px", backgroundColor: "rgba(201,168,76,0.4)", mb: 1.5 }} />
              <Typography sx={{ color: "text.secondary", fontSize: { xs: "0.75rem", md: "0.85rem" }, lineHeight: 1.8 }}>{desc}</Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  </CreamBg>
);

/* ─── LIVRAISON BANNER ──────────────────────────────────── */
const LivraisonBanner = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ position: "relative", overflow: "hidden", py: { xs: 7, md: 10 }, background: 'url("/images/bedroom-1.jpg") center/cover no-repeat', "&::before": { content: '""', position: "absolute", inset: 0, zIndex: 1, background: "rgba(10,6,2,0.82)" } }}>
      <Container maxWidth="md" sx={{ position: "relative", zIndex: 2, textAlign: "center", px: { xs: 2, md: 3 } }}>
        <LocalShippingIcon sx={{ fontSize: { xs: 28, md: 36 }, color: "secondary.main", mb: 2 }} />
        <Typography variant="h3" sx={{ color: "#fff", fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: { xs: "1.3rem", md: "2.2rem" }, mb: 2, textTransform: "uppercase", letterSpacing: "0.05em" }}>
          Collecte & Livraison à Marrakech
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, mb: 3 }}>
          <Box sx={{ width: 50, height: "1px", backgroundColor: "rgba(201,168,76,0.4)" }} />
          <Box sx={{ width: 5, height: 5, backgroundColor: "secondary.main", transform: "rotate(45deg)" }} />
          <Box sx={{ width: 50, height: "1px", backgroundColor: "rgba(201,168,76,0.4)" }} />
        </Box>
        <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: { xs: "0.88rem", md: "1rem" }, lineHeight: 1.9, maxWidth: 520, mx: "auto", mb: 4 }}>
          Nous récupérons votre linge directement dans vos établissements et vous le livrons propre, repassé et emballé — selon votre planning.
        </Typography>
        <Button onClick={() => navigate("/contact")} variant="outlined" sx={{ borderColor: "secondary.main", color: "secondary.main", fontSize: { xs: "0.7rem", md: "0.78rem" }, letterSpacing: "0.15em", px: { xs: 4, md: 5 }, py: 1.6, borderRadius: 0, fontWeight: 700, transition: "all 0.3s ease", "&:hover": { backgroundColor: "secondary.main", color: "#1a0f05" } }}>
          Demander un Devis
        </Button>
      </Container>
    </Box>
  );
};

const HomePage = () => (
  <>
    <HeroSection />
    <StatsSection />
    <AboutSection />
    <ServicesSection />
    <WhyUsSection />
    <LivraisonBanner />
  </>
);

export default HomePage;